import { useEffect } from "react";
import { DetailsCoverageProps } from "./DetailsCoverage";
import { ButtonCust } from "../../widgets/Button/ButtonCust";
import { Grid, Typography, Box } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import styles from "./S5_DetailsCoverage.module.scss";
import { useNavigate } from "react-router-dom";

function DetailsCoverageCmp(props: DetailsCoverageProps) {
  let navigate = useNavigate();
  const { coverageCheckContent } = props;
  const { heading, back, iframeLink, iframeTitle, back_nav } =
    coverageCheckContent;
  const { details_coverage, iframeMapId } = styles;
  useEffect(() => {
    window.scroll(0, 0);
    let container = document.getElementById(iframeMapId);
    window.addEventListener(
      "message",
      function (e) {
        let message = e.data;
        if (message.map && message.height && container) {
          container.style.height = message.height + 350 + "px";
        }
      },
      false
    );
  }, []);
  return (
    <Grid container className={details_coverage} mt={{ xs: 6.8 }}>
      <Grid container direction="row" px={"40px"} py={"20px"}>
        <Grid
          item
          onClick={() => navigate(back_nav)}
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <ArrowBackIosIcon />
          &nbsp;
          {back}
        </Grid>
        <Grid item sx={{ mx: "auto" }}>
          <Typography variant="h4" lineHeight={2.5}>
            {heading}
          </Typography>
        </Grid>
      </Grid>

      <Grid container textAlign="center" mb={2.5}>
        <iframe
          id={iframeMapId}
          src={iframeLink}
          title={iframeTitle}
          loading="lazy"
        ></iframe>
      </Grid>
    </Grid>
  );
}

export default DetailsCoverageCmp;
